// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2374":"5ee574fe0fa53275","2676":"fd3c6e5000eb0251","3877":"fe336940f98fdfab","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};